import { render } from 'datocms-structured-text-to-plain-text';
import type { dummy_dummy_content_OmniQuickLinkRecord } from '~/types/generated/cms/dummy';
import type {
  getBlogPostBySlug_allBlogPosts_quickLinks,
  getBlogPostBySlug_allBlogPosts_quickLinks_quickLinkItems_ProductPageRecord_hero_newText_structuredText,
} from '~/types/generated/cms/getBlogPostBySlug';
import { notEmpty } from 'src/typeHelpers';
import QuickLinks from '../DatoCms/QuickLinks';
import type { IQuickLinkItem } from '../DatoCms/QuickLinkItem';
import type { StructuredText } from 'datocms-structured-text-utils';

function structuredTextToString(
  text: getBlogPostBySlug_allBlogPosts_quickLinks_quickLinkItems_ProductPageRecord_hero_newText_structuredText,
): string {
  return (
    render(text as unknown as StructuredText, {
      renderInlineRecord: () => null,
      renderLinkToRecord: () => null,
      renderBlock: () => null,
    }) ?? ''
  );
}

interface Props {
  block: dummy_dummy_content_OmniQuickLinkRecord;
}

const OmniQuickLinks: React.FC<Props> = ({ block }) => {
  const linkedItems = (block as getBlogPostBySlug_allBlogPosts_quickLinks).quickLinkItems.map(
    (item): IQuickLinkItem | null => {
      // Construct the correct slugs for nested pages
      const interSlug =
        'parentPage' in item
          ? [item.parentPage?.parentPage?.slug, item.parentPage?.slug].filter(Boolean).join('/') +
            '/'
          : '';
      switch (item.__typename) {
        case 'BlogPostRecord':
          return {
            id: item.id,
            responsiveImageData: item.image!.responsiveImage!,
            heading: item.title!,
            text: item.description!,
            to: `/blog/${item.slug!}`,
          };
        case 'LongReadRecord':
          return {
            id: item.id,
            responsiveImageData: item.image!.responsiveImage!,
            heading: item.title!,
            text: item.description!,
            to: `/woning-verduurzamen/product/${interSlug}${item.slug!}`,
          };

        case 'EnergySavingPageRecord':
          return {
            id: item.id,
            responsiveImageData: item.hero[0].image!.responsiveImage!,
            heading: item.name!,
            text: structuredTextToString(item.hero[0].newText[0].structuredText!),
            to: `/woning-verduurzamen/energie-besparen/${interSlug}${item.slug!}`,
          };
        case 'ProductPageRecord':
          return {
            id: item.id,
            responsiveImageData: item.hero[0]!.image!.responsiveImage!,
            heading: item.name!,
            text: structuredTextToString(item.hero[0].newText[0].structuredText!),
            to: `/woning-verduurzamen/product/${interSlug}${item.slug!}`,
          };
        case 'FinancingPageRecord':
          return {
            id: item.id,
            responsiveImageData: item.hero[0]!.image!.responsiveImage!,
            heading: item.name!,
            text: structuredTextToString(item.hero[0].newText[0].structuredText!),
            to: `/woning-verduurzamen/financiering/${interSlug}${item.slug!}`,
          };
        default:
          // Handle unexpected types
          console.warn(`Unexpected type: ${(item as any).__typename}`);
          return null;
      }
    },
  );

  const customItems = block.miscItems.map(
    (item): IQuickLinkItem => ({
      id: item.id,
      responsiveImageData: item.image!.responsiveImage!,
      heading: item.heading!,
      text: item.text!,
      to: item.url!,
    }),
  );

  // Combine linked and custom items, filter out nulls, and limit to 3 items
  const items = [...linkedItems, ...customItems].filter(notEmpty).slice(0, 3);

  return <QuickLinks title={block.title!} items={items} />;
};

export default OmniQuickLinks;
